<template>
  <div>
    <b-container fluid>
      <b-row>
        <!-- <b-col cols="12">
          <h3 class="text-center">Add and View Coupons <span class="smh"></span></h3>
        </b-col> -->
        <b-col cols="12">
            <div class="board-wrapper">
                <digit-board class="board-items" title="Total Earnings" symbol="N" :value="ambassadorrefs[0].totalearnings" color="green"></digit-board>
                <digit-board class="board-items" title="Total Payouts" symbol="N" :value="ambassadorrefs[0].totalpayout" color="green"></digit-board>
                <digit-board class="board-items" title="Balance Left" symbol="N" :value="ambassadorrefs[0].balance" color="green"></digit-board>
            </div>
            
            <div class="text-center mt-5"> 
                <div class="">
                    <b-modal centered id="modal-reqpayouts" title="Request Payout" hide-footer>
                        <template v-slot:default>
                            <div class="">
                                <p v-if="chkfieldsreq">Your commission balance is not up to the minimum request amount of N1000</p>     
                                <form @submit.prevent="requestpayout">
                                    <b-form-group label="Choose Amount to request" class="label" label-for="reqamount">
                                        <b-form-spinbutton id="reqamount" :disabled="chkthreshold" v-model="reqpayouts.amount" min="10" :max="ambassadorrefs[0].balance" step="1"></b-form-spinbutton>
                                        <b-form-input type="range" id="reqamount" :disabled="chkthreshold" v-model="reqpayouts.amount" min="10" :max="ambassadorrefs[0].balance"></b-form-input>
                                        <p>I am requesting for a Payout of N{{reqpayouts.amount}}</p>
                                    </b-form-group>

                                    <div v-if="sentreq" class="alert alert-success p-3">
                                        Payout Requested Successfully. Your request will be attended to inside the next 24hours of Payout period.
                                    </div>

                                    <div class="text-center">
                                        <b-overlay :show="sending" rounded
                                            opacity="0.6"
                                            spinner-small
                                            spinner-variant="primary"
                                            class=""
                                        >
                                            <div class="mt-4">
                                                <b-button :disabled="chkfieldsreq" type="submit" variant="outline-success" class="m-lg-3 mt-2 p-2 action-button"> Request Payout </b-button>
                                            </div>                  
                                        </b-overlay>

                                        <b-button v-if="sendingreq" @click="sendingreq = false" class="w-50 p-2 mt-3" variant="dark">
                                        Cancel
                                        </b-button>

                                    </div>
                                </form>
                            </div>
                        </template>
                    </b-modal>

                    <b-modal centered id="modal-account" title="Update Account Details" hide-footer>
                        <template v-slot:default>
                            <div class="">                       
                                <form @submit.prevent="updateambacct">

                                    <b-form-group label="Account Name" class="label" label-for="target">
                                        <b-form-input type="text" id="acct_name" @input="uppercasename()" v-model="ambassador.acct_name"></b-form-input>
                                    </b-form-group>

                                    <b-form-group label="Account Bank Name" class="label" label-for="target">
                                        <b-form-input type="text" id="acct_bank" v-model="ambassador.acct_bank"></b-form-input>
                                    </b-form-group>

                                    <b-form-group label="Account Number" class="label" label-for="target">
                                        <b-form-input type="text" id="acct_type" v-model="ambassador.acct_number"></b-form-input>
                                    </b-form-group>

                                    <b-form-group label="Account Type" class="label" label-for="target">
                                        <b-form-select v-model="ambassador.acct_type">
                                            <b-form-select-option value="null">--Select Course--</b-form-select-option>
                                            <b-form-select-option value="SAVINGS">SAVINGS</b-form-select-option>
                                            <b-form-select-option value="CURRENT">CURRENT</b-form-select-option>
                                        </b-form-select>
                                    </b-form-group>

                                    <div v-if="sent" class="alert alert-success p-3">
                                        Acct Details Updated Successfully
                                    </div>

                                    <div class="text-center">
                                        <b-overlay :show="sending" rounded
                                            opacity="0.6"
                                            spinner-small
                                            spinner-variant="primary"
                                            class=""
                                        >
                                            <div class="mt-4">
                                                <b-button :disabled="chkfields" type="submit" variant="outline-success" class="m-lg-3 mt-2 p-2 action-button"> Update Acct Details </b-button>
                                            </div>                  
                                        </b-overlay>

                                        <b-button v-if="sending" @click="sending = false" class="w-50 p-2 mt-3" variant="dark">
                                        Cancel
                                        </b-button>

                                    </div>
                                </form>
                            </div>
                        </template>
                    </b-modal>


                    <b-button class="p-lg-2 m-2" size="lg" v-b-modal.modal-reqpayouts variant="success">Request Payout</b-button>
                    <b-button class="p-lg-2 ml-lg-3 m-2" size="lg" v-b-modal.modal-account variant="info">Update Acct Details</b-button>
                    <!-- <b-button class="p-lg-2" @click="openambassador = true" variant="success">ambassador a Coupon Campaign</b-button> -->
                </div>
            </div>
        </b-col>
        
      </b-row>
      <b-row v-if="openambassador == true">
        <b-col class="m-1 p-3">
            
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-3">
          <h3 class="text-center">Payout History</h3>
          <!-- <p class="text-center">Click on any title to edit</p> -->
          <div class="text-center list-heads pt-1">
              <p class="head-p">S/N</p>
              <p class="head-p">Amount</p>
              <p class="head-p">Date Requested</p>
              <p class="head-p">Time Requested</p>
              <p class="head-p">Request Status</p>
              <p class="head-p">Payment Date</p>
              <p class="head-p"></p>
          </div>

          <div v-if="ambassadorrefs[0].count > 0">
              <payout-list class="mt-2 maxres" v-for="(payout, index) in useambassadorrefs" :sn="index + 1" :payout="payout" :key="index" :page="pages" :interval='intervalnum'></payout-list>
              <paginater v-if="ambassadorrefs[0].payoutdata.length > 0" :intervalnum="intervalnum" :pages="pages" :endss="endss" :endnum="endnum" :datalength="endss" @paginator="newPage" @changeInterval="effectInterval"></paginater>
          </div>
          <div v-else>
              <h3>No payouts requested yet.</h3> 
          </div>
          
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store"
import payoutList from '@/components/payoutList';
import Paginater from "@/components/Paginater"
import digitBoard from "@/components/digitBoard"
// import  ckeditor  from "@/js/ckeditorconfig"
// const { ClassicEditor, config } = ckeditor
// import axios from "axios";

export default {
  components: {
      payoutList,
      Paginater,
      digitBoard
  },

  data() {
    return {
        ambassador: this.getForm(),
        reqpayouts : this.getPayout(),
        sending: false,
        sendingreq : false,
        sent : false,
        sentreq : false,
        levels: [0, 1, 2, 3, 4, 5],
        startnum: 0,
        limitnum: this.endss,
        intervalnum: 10,
        endnum: 10,
        btnrange : this.endss,
        pages : 1,
        stockingdata : [{
            data : []
        }],
        dataretrieved : false,
        addresponse : "",
        openambassador : false,
        // editor : ClassicEditor,
        // config : config,
        isCheckingcode : false,
        couponexists : false,
        uploadingfile : false,
        uploadedfile : false,
        uploadmessage : "",
        mtype : "",
        filedir : ""
        // datacount : this.partnershipsarray[0].count
    };
  },
  beforeRouteEnter(to, from, next){

    //   let orgname = store.state.loginmaster.details.clearance_organization
        store.dispatch("dashboard/fetchAmbstat")
        next();
  },
  created(){

        this.ambassador = {
            acct_name : this.ambdetails.ambassador_account_name,
            acct_bank : this.ambdetails.ambassador_account_bank,
            acct_type : this.ambdetails.ambassador_account_type,
            acct_number : this.ambdetails.ambassador_account_number,
        }
  },
  computed: {
        ...mapState({
            users: (state) => state.admin.allusers,
            details : state => state.loginmaster.details,
            ambdetails : state => state.loginmaster.details.ambassador_details,
            ambassadorrefs : state => state.dashboard.ambstat,
            adminadded : state => state.admin.adminadded,
            environ : state => state.loginmaster.environ,
            origin : (state) => state.loginmaster.site_origin
        }),
        emails() {
        let emailss = this.users;
        return emailss.map((x) => x.email);
        },
        useambassadorrefs() {
            return this.ambassadorrefs[0].payoutdata.slice(this.startnum, this.endnum);
        },
        endss() {
            let end = this.ambassadorrefs[0].payoutdata.length;
            return end;
        },
        ranger(){
            let ranger = Math.ceil(this.ambassadorrefs[0].payoutdata.length/this.intervalnum)
            return ranger
        },
        chkfields(){
            if(this.sending ||  this.ambassador.acct_name.length <= 0 || this.ambassador.acct_bank.length <= 0 || this.ambassador.acct_type.length <= 0 
                || this.ambassador.acct_number.length <= 0 ){
                return true
            }else{
                return false
            }
        },
        chkfieldsreq(){
            if(this.sendingreq || this.chkthreshold){
                return true
            }else{
                return false
            }
        },
        chkthreshold(){
            if(this.ambassadorrefs[0].balance < 10){
                return true
            }else{
                return false
            }
        }
  },
  methods: {
        ...mapActions("dashboard", ["updateAmbacct","fetchAmbstat","requestPayout"]),
        getForm() {
            return {
                acct_type : "",
                acct_name : "",
                acct_bank : "",
                acct_number : "",
                email : ""
            };
        },
        getPayout(){
            return {
                amount : 0
            }
        },
        uppercasename(){
            this.ambassador.acct_name = this.ambassador.acct_name.charAt(0).toUpperCase() + this.ambassador.acct_name.slice(1);
        },
        requestpayout(){
            this.sendingreq = true;

            this.reqpayouts.email = this.ambdetails.ambassador_email
            this.reqpayouts.first_name = this.ambdetails.ambassador_first_name
            this.reqpayouts.last_name = this.ambdetails.ambassador_last_name

            return this.requestPayout(this.reqpayouts).then(() => {
                this.sendingreq = false;
                this.sentreq = true

                this.fetchAmbstat();
            });
        },
        updateambacct() {
            this.sending = true;
            this.ambassador.email = this.ambdetails.ambassador_email
            
            return this.updateAmbacct(this.ambassador).then(() => {
                this.sending = false;
                this.sent = true

                this.fetchAmbstat();
            });
        },
        newPage(page){
            // alert(page)
            this.pages = page
            let newend = this.intervalnum * page;

            if (newend < this.endss) {
                this.endnum = newend;
                this.startnum = newend - this.intervalnum ;
            } else {
                this.endnum = this.endss;
                this.startnum = newend - this.intervalnum ;
            }

        },
        effectInterval(newinterval){
            this.intervalnum = newinterval
            this.pages = 1
            this.newPage(this.pages)
        },

        checkCouponcode(){
            this.ambassador.couponcode = this.ambassador.couponcode.toUpperCase()

            if(this.ambassador.couponcode.length > 0){
                this.isCheckingcode = true
            }else{
                this.isCheckingcode = false
            }

            // alert(this.ambassador.couponcode)

            return this.checkCoupon(this.ambassador.couponcode).then((response) => {
                this.couponexists = response
                // console.log(response)
            })
        },
        stopproceed(){
            this.sending = false
        },
  },
  
};
</script>

<style scoped>
.list-heads {
    background-color: #00984A;
    color: white;
    border-radius: 5px 5px;
    font-weight: bold;
    display: flex;
    flex-flow: row wrap;
}
.head-p{
    width: 14%;
    padding: 2px;
}
.flex-input-parent{
    display: flex;
}
.left-flex-child{
    width: 95%;
}
.right-flex-child{
    width: 5%;
}
.hidden{
    display: none
}
.full-width-child{
    width : 100%
}
.font-green{
    color: green;
}
.errtxt{
    color: red;
}
.board-wrapper{
    display: flex;
    flex-flow : row wrap;
    justify-content: flex-start;
}
.board-items{
    width : 30%;
    margin: 3px;
}


@media screen and (max-width: 999px) {
     .head-p{
        font-size: 0.6rem
    }
    .page-buttons{
        width: 25px;
        height: 25px;
        padding: 0px 0px 0px 5px ;
    }
}
</style>
